"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showWarning = exports.throwError = void 0;
const throwError = (message) => {
    throw Error(`[Senn-node-feature-flags-frontend]: ${message}`);
};
exports.throwError = throwError;
const showWarning = (message) => {
    console.warn(`[Senn-node-feature-flags-frontend]: ${message}`);
};
exports.showWarning = showWarning;
